// Justifies paragraphs that are left-aligned (skipping those inside headings). Centered or right-aligned copy keeps
// its design alignment, since CSS alone can't tell which paragraphs are which.
(() => {
  const CLASS = 'is-justified';

  const isStartAligned = (p) => {
    if (p.closest('h1, h2, h3, h4, h5, h6')) return false;
    const { textAlign, direction } = getComputedStyle(p);
    return textAlign === 'start' || textAlign === (direction === 'rtl' ? 'right' : 'left');
  };

  const apply = (paragraphs) => {
    paragraphs.forEach((p) => p.classList.remove(CLASS));
    paragraphs.filter(isStartAligned).forEach((p) => p.classList.add(CLASS));
  };

  const applyAll = () => apply([...document.querySelectorAll('p')]);

  applyAll();

  // Alignment can change at breakpoints (e.g. sm:text-center)
  let lastWidth = window.innerWidth;
  let resizeTimer;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyAll, 150);
  });

  // Content rendered later (cart drawer, quiz results, search, theme editor)
  new MutationObserver((mutations) => {
    const added = [];
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches('p')) added.push(node);
        added.push(...node.querySelectorAll('p'));
      });
    });
    if (added.length) apply(added);
  }).observe(document.body, { childList: true, subtree: true });
})();
